import React from "react";
import {useParams} from "react-router-dom";
import './_forward.scss';
import CustomDogIcon, {DogColors, DogIcon} from "../customDogIcon/CustomDogIcon";

export const GetForwardTemplate = (company, application, token) => {

    let params = useParams();
    if (params.application && application !== {} && application.address !== null) {
        window.location = application.address + "?a=" + token;
    }
    return (
        <div className={"forwarding-container"}>
            <div className={"forwarding-container__title"}>{company.name} Sign-In To {application.name} Successful</div>

            <div>Please do not close this window while it is loading.</div>
            <CustomDogIcon className={"forwarding-container__success-dog"} dogColor={DogColors.primary}
                           IconType={DogIcon.SuccessDog}/>
            <div>Signing you in to {application.name}</div>
        </div>
    )
}
